export default __webpack_public_path__ + "static/media/github-octocat.8c284667.svg";